import React, { useContext } from "react";
import MissingValuesHistogram from "./MissingValuesHistogram";
import { SystemContext } from "../context";

const CustomPieCharts = ({ data }) => {
    const { numberOfRows, numberOfColumns, numberOfDuplicateRows, numberOfDuplicateColumns, numericalColumns, stringColumns } = useContext(SystemContext);
    const headingStyle = {
        color: '#152C73',
        marginRight: '1rem',
        display: 'flex'
    };

    return (
        <div style={{ display: 'flex', overflow : 'auto', maxHeight: '100%', width: '100%' }}>
            <div style={{ flex: '0 0 25%', padding: '20px', whiteSpace: 'nowrap', textAlign: 'left' }}>
            <h3 style={{ ...headingStyle, marginLeft: '1.5rem', minWidth: '200px', textAlign: 'left' }}><b>Data Summary</b></h3>
                <ul>
                    <li>Data Points : {numberOfRows} </li>
                    <li>Features : {numberOfColumns}</li>
                </ul>
                <h3 style={{ ...headingStyle, marginLeft: '1.5rem', minWidth: '200px', textAlign: 'left' }}><b>Duplicate Count</b></h3>
                <ul>
                    <li>Data Points : {numberOfDuplicateRows}</li>
                    <li>Features : {numberOfDuplicateColumns}</li>
                </ul>
                <h3 style={{ ...headingStyle, marginLeft: '1.5rem', minWidth: '200px', textAlign: 'left' }}><b>Column Distribution</b></h3>
                <ul>
                    <li>Numerical Features : {numericalColumns && numericalColumns.length}</li>
                    <li>Categorical Features : {stringColumns && stringColumns.length}</li>
                </ul>
            </div>
            <div style={{ flex: '1', padding: '10px', overflow: 'auto',border: '1px solid #ccc', }}>
                <MissingValuesHistogram data={data} />
            </div>
        </div>
    );
};

export default CustomPieCharts;
